// extracted by mini-css-extract-plugin
export default {"loaderPopup":"LoaderPopup_loaderPopup__xGZ1b"};